/**
 * Link e identidade visual do rastreio de cada transportadora.
 *
 * O número de rastreio já aparecia na tabela, mas como texto morto: o cliente
 * copiava e ia procurar no site da transportadora. Aqui ele vira link direto,
 * e a cor diz de quem é o envio sem precisar de mais uma coluna.
 */

const LINKS: Record<string, (tn: string) => string> = {
  FEDEX: (tn) =>
    `https://www.fedex.com/fedextrack/?trknbr=${encodeURIComponent(tn)}&cntry_code=br&locale=pt_br`,
  UPS: (tn) =>
    `https://www.ups.com/track?loc=pt_BR&requester=ST&tracknum=${encodeURIComponent(tn)}`,
};

/**
 * Cores das marcas, ajustadas para texto pequeno sobre fundo claro.
 *
 * O roxo da FedEx é o oficial (#4D148C). O da UPS não dá: a marca é marrom com
 * dourado #FFB500, que em texto de 12px fica ilegível — contraste perto de 2:1.
 * Usamos um laranja escuro, que ainda lê como UPS e passa em contraste.
 */
const CORES: Record<string, string> = {
  FEDEX: "#4D148C",
  UPS: "#B45309",
};

const normalizar = (carrier?: string | null): string =>
  String(carrier ?? "").trim().toUpperCase();

/** URL de rastreio da transportadora, ou null se não souber montar. */
export const urlRastreio = (
  carrier?: string | null,
  trackingNumber?: string | null,
): string | null => {
  const tn = String(trackingNumber ?? "").trim();
  if (!tn || tn === "—") return null;

  const montar = LINKS[normalizar(carrier)];
  return montar ? montar(tn) : null;
};

/** Cor da marca, ou undefined para herdar a cor do texto da tabela. */
export const corTransportadora = (carrier?: string | null): string | undefined =>
  CORES[normalizar(carrier)];
